import {ACTION_TYPES} from '../app.types';
import {PartnerAction} from './partner.service';
import {PartnerModel} from './partner.model';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {usersFeatureSelector} from '../user/user.reducer';

export function partnersContainer(state = {partners: [], error: null},
                                  action: PartnerAction = {type: '?'}) {

  switch (action.type) {
    case ACTION_TYPES.PARTNER_LIST_GET:
      return {...state, partners: action.partners};
    case ACTION_TYPES.PARTNER_LIST_GET_ERROR:
      return {...state, error: action.error};
    default:
      return state;
  }
}

export const partnersFeatureSelector = createFeatureSelector<{ partners: PartnerModel[], error: any }>('partnersContainer');
export const partnerNameByCurrentPartnerIdSelector = createSelector(partnersFeatureSelector,
  usersFeatureSelector,
  (partnersSlice, user) => partnersSlice.partners
    .find(partner => partner.id === user.user.partnerId)?.name);

export const partnerListSelector = (state: any): PartnerModel[] => state.partnersContainer.partners;

export const partnerForIdSelector = ((state: any, id: number): PartnerModel => {
  return state.partnersContainer.partners.find((partner: PartnerModel) => {
    return partner.id === id;
  });
});
